import { render, staticRenderFns } from "./PZBroadcast.vue?vue&type=template&id=05903f2c&scoped=true&"
import script from "./PZBroadcast.vue?vue&type=script&lang=js&"
export * from "./PZBroadcast.vue?vue&type=script&lang=js&"
import style0 from "./PZBroadcast.vue?vue&type=style&index=0&id=05903f2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05903f2c",
  null
  
)

export default component.exports